import styled from 'styled-components';
import { color, container, fontSize, fontWeight, radius, spacing } from 'theme';
export const StyledContainer = styled.div`
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin-bottom: ${spacing('sm')};

  &.experience-table {
    max-width: ${container('md')};
  }

  thead th {
    border-bottom: 1px solid ${color('midnight_200')};
    font-size: ${fontSize('sm')};
    line-height: 1.14;
    padding-bottom: ${spacing('sm')};
    font-weight: ${fontWeight('medium')};
  }

  tbody th {
    text-align: right;
    font-weight: ${fontWeight('medium')};
    padding-right: ${spacing('sm')};
    white-space: nowrap;
  }

  tbody tr {
    transition: 0.3s;
  }

  tr:first-of-type th,
  tr:first-of-type td {
    padding-top: ${spacing('sm')};
  }

  &:hover tbody tr {
    opacity: 0.5;
  }

  tbody tr:hover {
    opacity: 1;
  }
`;

export const StyledValue = styled.div`
  margin: ${spacing('xs2')};
  min-width: 4.5rem;
  height: 2.25rem;
  border-radius: ${radius('sm')};
  color: ${color('text_white')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('extraBold')};

  &.cell-color-1 {
    background-color: ${color('ylgnbu_02')};
  }
  &.cell-color-2 {
    background-color: ${color('ylgnbu_03')};
  }
  &.cell-color-3 {
    background-color: ${color('ylgnbu_04')};
  }
  &.cell-color-4 {
    background-color: ${color('ylgnbu_05')};
  }
  &.cell-color-5 {
    background-color: ${color('ylgnbu_06')};
  }
  &.cell-color-6 {
    background-color: ${color('ylgnbu_07')};
  }
  &.cell-color-7 {
    background-color: ${color('ylgnbu_08')};
  }
  &.cell-color-8 {
    background-color: ${color('ylgnbu_09')};
  }
`;
